
import { useEffect, useRef } from "react";

const ElevenLabsWidget = () => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Create and append the custom element
        const convaiElement = document.createElement("elevenlabs-convai");
        convaiElement.setAttribute("agent-id", "1Xo39zyIciDaq0IDbXaz");

        if (containerRef.current) {

            if (containerRef?.current) {
                containerRef?.current.appendChild(convaiElement);
            }
        }

        // Dynamically load the script
        const script = document.createElement("script");
        script.src = "https://unpkg.com/@elevenlabs/convai-widget-embed";
        script.async = true;
        script.type = "text/javascript";
        document.body.appendChild(script);

        // Optional cleanup if needed
        return () => {
            if (containerRef.current) {
                containerRef.current.innerHTML = "";
            }
            document.body.removeChild(script);
        };
    }, []);

    return <div ref={containerRef} />;
};

export default ElevenLabsWidget;